export default __webpack_public_path__ + "static/media/card13.ecb85c6a.png";